import type { CmpHider } from './types';

export const enzuzo: CmpHider = {
  id: 'enzuzo',
  label: 'Enzuzo',
  css: `
      /* Enzuzo (enzuzo.com CMP): the cookie banner script injects its UI directly
         onto <body> as "enzuzo-"/"ez-"-namespaced pieces. The visible notification
         is a fixed container "#ez-cookie-notification" (.enzuzo-cookiebanner-container,
         position:fixed, z-index 2147483647) holding the message and Accept/Decline
         buttons; hiding it removes the banner. The cookie-preferences and
         "do not sell" modals each render in a fixed full-viewport wrapper carrying
         the ".enzuzo-modal-wrapper" class ("#enzuzo-modal-wrap" /
         "#enzuzo-donotsell-modal-wrap", z-index 2147483647) that doubles as the
         dimming backdrop, with the modal card itself in ".enzuzo-cookie-modal"
         ("#enzuzo-modal" / "#enzuzo-donotsell-modal"); hiding the wrapper removes an
         opened modal and its faded background in one go, and we list the modal card
         defensively. The "enzuzo-"/"ez-cookie-" hooks are specific to the Enzuzo
         consent UI, so this does not touch unrelated page content. Enzuzo does not
         lock page scroll via a body class or inline style on the sites observed; if a
         build does, the html/html-body [style*="overflow"] and [style*="position:
         fixed"] release rules above already out-specify an inline overflow/position
         lock. */
      #ez-cookie-notification,
      .enzuzo-cookiebanner-container,
      .enzuzo-modal-wrapper,
      .enzuzo-cookie-modal { display: none !important; }
  `,
};
